module.exports = __webpack_public_path__ + "static/media/profile-avatar.c65843a5.jpg";